import {Link} from 'shells/link/link';
import {LoadingText} from 'shells/loading-placeholder/loading-text';
import {SelectTwoLine} from 'shells/select-two-line/select-two-line';
import type {TwoLineOption} from 'shells/select-two-line/select-two-line';
import {Body} from 'shells/typography/body';

import {useGetCallTrackerNumbers} from '../../graphql/hooks/use-get-calltracker-numbers';

type Props = {
    id: string;
    onChangeId: (value: string) => void;
    onChangeNumber: (value: string) => void;
};

export const CallTrackerSelect = (props: Props) => {
    const {callTrackerNumbers, isLoading} = useGetCallTrackerNumbers();

    if (isLoading) {
        return <LoadingText height={32} isFullWidth={true} />;
    }

    if (!callTrackerNumbers || callTrackerNumbers.length === 0) {
        return (
            <Body size='small'>
                You haven’t configured CallTrackerFX yet! Head on over to the{' '}
                <Link
                    href='https://app.webfx.com/revenuecloudfx/calltracker/configuration'
                    newTab={true}
                    size='small'
                    variant='primary'
                >
                    setup guide
                </Link>{' '}
                to get started.
            </Body>
        );
    }

    const options: TwoLineOption[] = callTrackerNumbers.map((number) => {
        return {
            label: number.label,
            sublabel: number.match,
            value: number.id,
        };
    });

    const selectedOption: TwoLineOption | undefined = options.find(
        (option) => option.value === props.id
    );

    return (
        <SelectTwoLine
            options={options}
            onChange={(value: TwoLineOption) => {
                props.onChangeId(value.value);
                props.onChangeNumber(value.sublabel);
            }}
            value={selectedOption}
        />
    );
};
